export default {
  hitsStyleList: [
    'ストップ',
    'つっつき',
    'フリック',
    'チキータ',
    'ドライブ',
    'スマッシュ',
    'プッシュ',
    'ブロック',
    'カットブロック',
    'ロビング',
    'フィッシュ',
    'カット',
  ],
  courseList: [
    'バック前サイド',
    'フォア前サイド',
    'バック前',
    'フォア前',
    'ミドル前',
    'ミドル',
    'バック',
    'フォア',
    'バックサイド',
    'フォアサイド',
  ],
  outList: [
    'ネットミス',
    'オーバーミス',
    'サイドオーバーミス',
    'ノータッチ',
    '空振り',
    '当て損じ',
  ],
  inList: [
    '該当なし',
    'ネットイン',
    'エッジ',
    'チャンスボール',
  ],
  serveList: [
    '順横',
    '縦回転',
    '巻き込み',
    'YG',
    'しゃがみ込み',
  ],
  handList: [
    'フォアハンド',
    'バックハンド',
  ],
  hitPostionAtServe: [
    'バック',
    'ミドル',
    'フォア',
  ],
  hitPostion: [
    '前陣',
    '中陣',
    '後陣',
  ],
  hitPostionAtServeOption: [
    { text: 'バック', value: 0 },
    { text: 'ミドル', value: 1 },
    { text: 'フォア', value: 2 },
  ],
  hitPostionOption: [
    { text: '前陣', value: 0 },
    { text: '中陣', value: 1 },
    { text: '後陣', value: 2 },
  ],
};



// WEBPACK FOOTER //
// ./src/lib/cmnConst.js